import { Link } from 'features/i18n/router'
import { Breadcrumb } from 'lib/_types'

export const Breadcrumbs = ({ breadcrumbs }: { breadcrumbs: Breadcrumb[] }) => {
  return (
    <ul className="Main__breadcrumb">
      {breadcrumbs.map(({ title, link }, i) => (
        <li key={i}>
          {link ? <Link to={link}>{title}</Link> : <span>{title}</span>}
        </li>
      ))}
    </ul>
  )
}
